<template>
  <div v-if="subjob && subjob.Machine">
    <!--  v-click-outside="unfocusEntireCard" -->
    <v-card class="mb-4" elevation="1">
      <v-form v-model="valid">
        <v-card flat
          :style="valid ? (subjob.New ? 'border: 1px solid green !important;' : '') : 'border: 1px solid red !important;'"
          :color="valid ? (subjob.New ? '#FAFFFA' : '') : '#FBF8F8'">
          <v-card v-if="!isPastApproved && !customerLoading && Machine.CustomerId != customerId" color="warning"
            class="rounded-0 px-3 py-1" flat dark>
            {{ $t('servicesystem.common_objects.machine.registered_to_diff_customer') }}
          </v-card>
          <v-container class="d-flex pa-2" fluid
            :style="Machine.IsActive ? '' : 'background-color: rgba(0, 0, 0, 0.07); !important;'">
            <div class="mr-3 my-auto" style="position: relative;">
              <div style="position: absolute; z-index: 10; top: -12px; right: -12px;">
                <MachineFlag v-if="!subjob.New && !isNew" :flagvalue="subjob.Flag" :jobId="subjob.Id"
                  :machineId="subjob.Machine.Id" />
              </div>
              <MachineModelImage :size="50" :relativePath="MachineModel && MachineModel.ModelImage"
                :modelId="MachineModel && MachineModel.Id" @click="modelDialog = !modelDialog">
              </MachineModelImage>
              <MachineModelDialog2 v-model="modelDialog" :machine="Machine"
                :modelId="MachineModel && MachineModel.Id" />
            </div>

            <v-col cols="0" class="pa-0 d-flex flex-column justify-center">
              <v-row no-gutters class="flex-grow-0">
                <h4 class="align-self-center" :class="Machine.IsActive ? 'useThemeTextColor' : 'deactivated'"
                  v-text="machineGeneralizerText(subjob.Machine)" />
              </v-row>
              <v-row no-gutters class="flex-grow-0">
                <router-link :to="{ name: 'ViewMachine', params: { machineId: subjob.Machine.Id } }"
                  class="onlyshowlinkonhover">
                  <h4 class="align-self-center" :class="Machine.IsActive ? 'primary--text' : 'deactivated'"
                    v-text="machineIdentifierText(subjob.Machine)">
                  </h4>
                </router-link>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <v-row justify="end">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :disabled="disabled"
                      v-if="!subjob.New && checkPermission('Actions', 'editSubjob') && !isHiddenJobStatus(subjob)"
                      v-bind="attrs" v-on="on" icon @click="editMode ? cancel() : (editMode = true)" small>
                      <v-icon :color="editMode ? 'error' : ''">{{ editMode ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ editMode ? $t("servicesystem.text.cancel") : $t("servicesystem.text.edit") }}</span>
                </v-tooltip>

                <v-tooltip bottom v-if="false && subjob.New">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small v-bind="attrs" v-on="on" icon :class="isPhoneBool ? 'mx-0' : 'mx-2'" @click="remove()">
                      <v-icon :color="'error'" v-text="'mdi-delete'">
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('servicesystem.common_objects.commonterms.remove') }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon @click="open = !open" small>
                      <v-icon v-text="open ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                    </v-btn>
                  </template>
                  <span>{{ open ? $t("servicesystem.text.close_machine_details") :
                    $t("servicesystem.text.open_machine_details") }}</span>
                </v-tooltip>

                <ActionMenu v-if="!subjob.New" :actionList="actionlist" :parentcontext="thiscontext"
                  :disabled="disabled">
                </ActionMenu>
              </v-row>

              <v-row justify="end" class="mt-4">
                <MachineServiceAgreementIcon v-if="subjob.Machine" :machine="subjob.Machine"
                  @Update="applyServiceAgreementUpdate">
                </MachineServiceAgreementIcon>

                <MachineContractIcon v-if="subjob.Machine" :machine="subjob.Machine" class="mx-1">
                </MachineContractIcon>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="jobsdialogtrigger++" v-bind="attrs" v-on="on" icon color="primary" class="" small>
                      <v-icon v-text="'mdi-briefcase-search'" />
                    </v-btn>
                  </template>
                  <span v-text="$t('servicesystem.common_objects.customer.other_jobs')" />
                </v-tooltip>
              </v-row>
            </v-col>
          </v-container>
          <v-divider />
          <v-list dense class="py-0">
            <v-container class="px-0 py-0" fluid>
              <v-row no-gutters style="background-color: #f9f9f9;">
                <QTextArea v-model="subjob.CustomerComment" :disabled="disabled"
                  :label="$t('servicesystem.common_objects.machine.edit.customer_comment')"
                  :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampJobDescription"
                  :externaledit="subjob.New || editMode" :backgroundcolor="'#f9f9f9'" @FocusState="editMode = true"
                  :rules="[requiredRule]" class="mx-3">
                </QTextArea>
              </v-row>

              <v-divider />

              <v-row class="ma-0 my-n1">
                <v-col v-if="!isNew" :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
                  <QAutoComplete v-model="subjob.JobTypeId" :label="$t('servicesystem.common_objects.job.type')"
                    :list="typeList" :textkey="'Name'" :valuekey="'Id'" :rules="[requiredRule]"
                    :externaledit="subjob.New || editMode" @FocusState="editMode = true">
                  </QAutoComplete>
                </v-col>
                <v-col :cols="isPcBool ? (!isNew ? 4 : 6) : (isPhoneBool ? 12 : 6)">
                  <SupplierFailureCodeSelect v-model="subjob.SupplierFailureCodeId" allowCreate
                    :filter="{ SupplierIdList: SupplierId ? [SupplierId] : undefined }" clearable hideIcon disableAttach
                    :disabled="!SupplierId" :externaledit="subjob.New || editMode" @FocusState="editMode = true">
                  </SupplierFailureCodeSelect>
                </v-col>
                <v-col :cols="0">
                  <RepairCodeSelect v-model="subjob.RepairCodes" allowCreate returnobject clearable multiple hideIcon
                    disableAttach :externaledit="subjob.New || editMode" @FocusState="editMode = true">
                  </RepairCodeSelect>
                </v-col>
              </v-row>

              <v-row class="ma-0 my-n1">
                <v-col :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
                  <RepairPlaceSelect v-model="subjob.RepairPlaceId" allowCreate clearable hideIcon
                    :externaledit="subjob.New || editMode" @FocusState="editMode = true">
                  </RepairPlaceSelect>
                </v-col>
                <v-col :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
                  <WarrantyTypeSelect v-model="subjob.WarrentyTypeId" allowCreate clearable hideIcon
                    :externaledit="subjob.New || editMode" @FocusState="editMode = true">
                  </WarrantyTypeSelect>
                </v-col>
                <v-col :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
                  <QAutoComplete v-model="subjob.JobCategoryId"
                    :label="$t('servicesystem.common_objects.job.job_category')" :list="jobCategoryList"
                    :textkey="'Name'" :valuekey="'Id'" clearable :disabled="isPastApproved"
                    :externaledit="subjob.New || editMode" @FocusState="editMode = true">
                  </QAutoComplete>
                </v-col>
              </v-row>

              <v-divider v-if="!isNew && !subjob.New" />

              <v-row no-gutters>
                <v-col :cols="(subjob.InvoiceComment || subjob.TechnicianComment) ? 12 : 6"
                  style="background-color: #fff0f6;">
                  <QTextArea v-if="!isNew && !subjob.New" v-model="subjob.TechnicianComment"
                    :label="$t('servicesystem.common_objects.machine.edit.technician_comment')"
                    :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampTechnicianComment"
                    :backgroundcolor="'#fff0f6'" :singleline="!subjob.TechnicianComment"
                    :placeholder="!subjob.TechnicianComment ? $t('servicesystem.common_objects.machine.edit.technician_comment') : undefined"
                    :externaledit="editMode" @FocusState="editMode = true" class="mx-3">
                  </QTextArea>
                </v-col>
                <v-col :cols="(subjob.InvoiceComment || subjob.TechnicianComment) ? 12 : 6"
                  style="background-color: #edfffd;">
                  <QTextArea v-if="!isNew && !subjob.New" v-model="subjob.InvoiceComment"
                    :label="$t('servicesystem.common_objects.machine.edit.invoice_comment')"
                    :backgroundcolor="'#edfffd'" :singleline="!subjob.InvoiceComment"
                    :placeholder="!subjob.InvoiceComment ? $t('servicesystem.common_objects.machine.edit.invoice_comment') : undefined"
                    :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampInvoiceComment"
                    :externaledit="editMode" @FocusState="editMode = true" class="mx-3">
                  </QTextArea>
                </v-col>
              </v-row>
            </v-container>
          </v-list>
          <edit-bar :externalTrigger="(editMode || subjob.New)" :saveable="valid" :dividerPos="'top'"
            :saveText="subjob.New ? $t('servicesystem.common_objects.commonterms.create') : $t('servicesystem.common_objects.commonterms.save')"
            @saveEmit="subjob.New ? create() : change()">
            <template v-slot:cancelbtn>
              <v-btn color="close" outlined small :elevation="0" @click="subjob.New ? remove() : cancel()">
                <v-icon size="15" class="mr-1">{{ subjob.New ? 'mdi-delete' : 'mdi-close' }}</v-icon>
                {{ subjob.New ? $t('servicesystem.common_objects.commonterms.remove') :
                  $t('servicesystem.common_objects.commonterms.cancel') }}
              </v-btn>
            </template>
            <template v-if="isNew" v-slot:savebtn>
              <div></div>
            </template>
          </edit-bar>
        </v-card>
      </v-form>
      <!--<PopOverPane v-model="showPopOver" /> -->
      <MachineContentCard v-if="open" :Machine="subjob.Machine" :Subjob="subjob" />
    </v-card>

    <TransferMachineWorkDialog
      :optionFilter="{ CustomerId: customerId, ExcludeItemIdList: usedMachineIds, ActiveState: 0 }" :machineJob="subjob"
      :externaltrigger="transferworkdialogtrigger" />
    <MachineConnectedJobsDialog :machine="subjob.Machine" :externaltrigger="jobsdialogtrigger" />
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import MachineConnectedJobsDialog from "@/components/Dialogs/MachineConnectedJobsDialog.vue";
import MachineModelDialog2 from "@/components/Dialogs/MachineModelDialog2.vue";
import TransferMachineWorkDialog from "@/components/Dialogs/TransferMachineWorkDialog.vue";
import RepairCodeSelect from "@/components/Inputs/EntityDropdowns/RepairCodeSelect2.vue";
import RepairPlaceSelect from "@/components/Inputs/EntityDropdowns/RepairPlaceSelect2.vue";
import SupplierFailureCodeSelect from "@/components/Inputs/EntityDropdowns/SupplierFailureCodeSelect2.vue";
import WarrantyTypeSelect from "@/components/Inputs/EntityDropdowns/WarrantyTypeSelect2.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import MachineMixin from "@/helpers/Mixins/MachineMixin.js";
import MachineContentCard from "@/views/job/newjob/cards/machines/ExpandedMachineCard.vue";
import MachineFlag from "@/views/job/newjob/cards/machines/MachineFlag.vue";
import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";
import MachineServiceAgreementIcon from "@/views/job/newjob/cards/machines/MachineServiceAgreementIcon.vue";
import MachineContractIcon from "@/views/job/newjob/cards/machines/MachineContractIcon.vue";
import Vue from "vue";
//import PopOverPane from "@/views/layouts/MachineHistoryPopOverPane.vue";

export default {
  name: "MachineJobCard",
  props: ["subjobId", "isNew", "disabled"],
  components: {
    ActionMenu,
    EditBar,
    MachineConnectedJobsDialog,
    MachineFlag,
    MachineServiceAgreementIcon,
    MachineContractIcon,
    MachineContentCard,
    MachineModelImage,
    MachineModelDialog2,
    TransferMachineWorkDialog,
    SupplierFailureCodeSelect,
    RepairCodeSelect,
    RepairPlaceSelect,
    WarrantyTypeSelect,
    //PopOverPane,
  },
  mixins: [MachineMixin],

  data() {
    return {
      jobsdialogtrigger: 1,
      transferworkdialogtrigger: 1,
      open: false,

      copyObject: {},
      editMode: false,
      valid: true,
      loading: false,

      showPopOver: false,
      modelDialog: false,

      thiscontext: this,
    };
  },

  beforeDestroy() {
    if (this.editMode) {
      this.cancel();
    }
  },

  methods: {
    create() {
      this.loading = true;
      const dto = Object.assign({}, this.subjob);
      dto.Id = -1;
      //console.log("Sent", dto);
      clientAPI.methods
        .createSubjob(dto)
        .then((response) => {
          response.PreNewId = this.subjob.Id;
          //console.log("Recived", response);
          this.$store.dispatch("JobHub/JobUpdater/UpdateSubjob", response);
        })
        .catch((e) => console.error(e))
        .finally(() => (this.loading = false));
    },

    change() {
      this.loading = true;
      const dto = Object.assign({}, this.subjob);
      //console.log("Sent", dto);
      clientAPI.methods
        .changeSubjob(dto)
        .then((response) => {
          //console.log("Recived", response);
          this.$store.dispatch("JobHub/JobUpdater/UpdateSubjob", response);
          this.editMode = false;
        })
        .catch((e) => console.error(e))
        .finally(() => (this.loading = false));
    },

    applyServiceAgreementUpdate(update) {
      Vue.set(this.subjob, "Machine", update.Machine);
      //this.subjob.Machine = update.Machine;
    },

    async remove() {
      if (!this.subjob.New) {
        var config = {
          title: this.$t("servicesystem.common_objects.machine.remove_confirm.title"),
          message: this.$t("servicesystem.common_objects.machine.remove_confirm.body"),
        };
        var result = await this.$store.dispatch("ConfirmDialog/Show", config);
        if (result) {
          this.storeRemove();
        }
      } else {

        this.storeRemove();
      }
    },

    openMachineInNewTab() {
      let newPageRoute = this.$router.resolve({ name: "ViewMachine", params: { machineId: this.Machine.Id } });
      window.open(newPageRoute.href, "_blank");
    },

    storeRemove() {
      //console.log('storeRemove', this.subjob);
      this.$store.dispatch("JobHub/JobSubjobs/removeSubjob", {
        jobId: this.subjob.New ? -1 : this.subjob.Id,
        machineId: this.Machine.Id,
      });
    },

    transferMachineWork() {
      this.transferworkdialogtrigger++;
    },

    /*
    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        //console.log("click outside");
        this.cancel();
      }
    },
    */
    cancel() {
      //console.log('cancel', Object.assign({}, this.subjob));
      //console.log('cancel 2', Object.assign({}, this.copyObject));
      if (this.subjob && !this.subjob.New) {
        this.subjob = this.copyObject;
      }
      this.editMode = false;
    },
  },

  computed: {
    jobCategoryList() {
      return this.$store.getters["LookUpStore/JobCategoryList"];
    },

    usedMachineIds() {
      return this.$store.getters["JobHub/Subjobs"].map(x => x.Machine?.Id);
    },
    customerId() {
      return (this.$store.getters["JobHub/JobCustomer/Customer"])?.Id;
    },
    customerLoading() {
      return this.$store.getters["JobHub/JobCustomer/CustomerLoading"];
    },
    subjob: {
      get() {
        var object = this.$store.getters["JobHub/JobSubjobs/ChildJob"](this.subjobId);

        return object;
      },
      set(newValue) {
        this.$store.dispatch("JobHub/JobSubjobs/replaceSubjob", newValue);
      },
    },
    Machine() {
      return this.subjob && this.subjob.Machine ? this.subjob.Machine : null;
    },

    MachineModel() {
      return this.Machine && this.Machine.MachineModel ? this.Machine.MachineModel : null;
    },

    SupplierId() {
      return this.MachineModel && this.MachineModel.Supplier ? this.Machine.MachineModel.Supplier.Id : null;
    },

    IsChanged() {
      if (this.subjob && this.copyObject) {
        return !this.SameValue(this.subjob, this.copyObject);
      } else {
        return false;
      }
    },
    IsSaveable() {
      return this.valid && this.IsChanged;
    },

    JobDetails() {
      return this.$store.getters["JobHub/JobParentjob/JobDetails"];
    },
    isPastApproved() {
      return this.JobDetails && this.JobDetails.JobStatusId && this.JobDetails.JobStatusId >= 70 ? true : false;
    },

    actionlist() {
      var list = [
        { '#': 1, title: this.$t("servicesystem.text.open_machine_in_new_tab"), icon: "mdi-open-in-new", iconsize: 18, hovercolor: "primary", method: "openMachineInNewTab" },
        //{ '#': 2, title: this.$t("servicesystem.text.split_off_machine"), icon: "mdi-call-split", iconsize: 22, hovercolor: "tertiary", method: "transferMachineWork" },
        { '#': 3, title: this.$t("servicesystem.text.transfer_machine_action"), icon: "mdi-swap-horizontal", hovercolor: "warning", method: "transferMachineWork", disabled: this.disabled },
        { '#': 4, title: this.$t("servicesystem.text.remove_machine_from_job"), icon: "mdi-delete", iconsize: 18, hovercolor: "error", method: "remove", disabled: this.disabled },
      ];
      if (!this.usedMachineIds || this.usedMachineIds.length < 2) {
        list = list.filter(x => x['#'] != 2)
      }
      return list;
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    typeList() {
      var list = this.$store.getters["LookUpStore/JobTypeList"];
      return list && list.length ? list : [];
    },
  },

  watch: {
    editMode: function (newVal) {
      if (newVal) {
        this.copyObject = Object.assign({}, this.subjob);
      }
    },
  },
};
</script>


<style>
.uplifted {
  z-index: 10;
}

.onlyshowlinkonhover:not(:hover) {
  text-decoration: none;
}

.deactivated:not(:hover) {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>